import { GoogleAnalyticsService } from 'app/google-analytics.service';
import {Component, ComponentFactoryResolver, ComponentRef, ElementRef, EventEmitter, HostListener, Input, NgZone, OnDestroy, OnInit, Output, ViewChild, ViewContainerRef} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {MatLegacyButton as MatButton} from '@angular/material/legacy-button';
import {MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef} from '@angular/material/legacy-dialog';
import {Router} from '@angular/router';
import {IdexService} from 'app/idex.service';
import {UploadService} from '../upload.service';
import {DownloadFolderComponent} from '../download-folder/download-folder.component';
import {MoveDialogComponent} from '../move/move.component';
import {UploadFilesComponent} from '../upload-files/upload-files.component';
import {VersionHistoryComponent} from '../version-history/version-history.component';
import {SharingComponent} from '../sharing/sharing.component';
import {TranslateService} from '@ngx-translate/core';
import {Mimetype} from 'app/shared/mimetype';
import {MomentPipe} from 'app/shared/moment.pipe';
import {OneDrive} from '../onedrive/onedrive.service';
import {Path} from 'app/shared/path';
import {Toast} from 'app/shared/toast/toast';
import {ConfirmDeleteComponent} from '../confirm-delete/confirm-delete.component';
import {ConfirmRestoreComponent} from '../confirm-restore/confirm-restore.component';
import {ConfirmPermanentDeleteComponent} from '../confirm-permanent-delete/confirm-permanent-delete.component';
import {WaitForImportComponent} from '../google-drive/wait-for-import.component';
import {DocTypeComponent} from '../../shared/doctype.component';
import {NewTaskComponent} from 'app/e-signature/tasks/new-task/new-task.component';
import {SignDialogComponent} from 'app/e-signature/sign-document/sign-dialog/sign-dialog.component';
import {AppComponent} from 'app/app.component';
import {CorporatePermissionComponent} from '../corporate-permission/permission.component';
import {DomSanitizer} from '@angular/platform-browser';
import {DeleteCommentComponent} from '../delete-comment/delete-comment.component';
import {UploadNewVersionComponent} from '../annotation-controller/upload-new-version/upload-new-version.component';
import WebViewer, {Core, WebViewerInstance, WebViewerOptions} from '@pdftron/webviewer';
import {environment} from '../../../environments/environment';
import {AnnotationControllerService} from '../annotation-controller/annotation-controller.service';
import {DownloadListComponent} from '../annotation-controller/download-list/download-list.component';
import {Observable} from 'rxjs';
import { AppLoaderComponent } from 'app/shared/app-loader/app-loader.component';
import { zDoxItem } from '../../shared/types';
import {SocialLogin} from "../../account/social-login";

declare let $: any;

@Component({
   selector: 'app-doclist',
   templateUrl: './doclist.component.html',
   styleUrls: ['./doclist.component.css'],
   animations: [
      trigger('tabChange', [
         state('hide', style({
            display: 'none',
            opacity: 0
         })),
         state('show', style({
            display: 'block',
            opacity: 1
         })),
         transition('hide => show', animate('150ms ease-in')),
         transition('show => hide', animate('150ms ease-out'))
      ])
   ]
})
export class DocListComponent implements OnInit, OnDestroy {
   private readonly SCOPE = 'https://www.googleapis.com/auth/drive.file';
   @Input() selectedItems: any[];
   @Input() search = false;
   @Input() trash = false;
   @Input() myfile = false;
   @Input() role = 'Admin';
   @Input() tin;
   @Input() shared = false;
   @Input() sharelink = false;
   @Input() hideInfo = false;
   @Input() canDrag = true;
   @Input() isListDoc = true;
   @Input() isDownload = true;
   @Input() sharedbyme = false;
   @Input() sharedwithme = false;
   @Output() clickitem = new EventEmitter<any>();
   @Output() loadmore = new EventEmitter<any>();
   @Output() showdocument = new EventEmitter<any>();
   @Output() searchpos = new EventEmitter<number>();
   @Output() uploadNewVersion = new EventEmitter<any>();
   @ViewChild('description') descElement: ElementRef;
   @ViewChild('fileUpload') fileUpload: any;
   @ViewChild('form1', {read: ViewContainerRef}) form1: ViewContainerRef;
   @ViewChild('form2', {read: ViewContainerRef}) form2: ViewContainerRef;
   @ViewChild('viewer') viewerRef: ElementRef;
   @ViewChild(AppLoaderComponent, { static: true }) loader: AppLoaderComponent;
   private signDialog: SignDialogComponent;
   private taskStatusMessage = {
      draftMsg: '',
      waitMsg: '',
      completeMsg: '',
      rejectMsg: '',
      deleteMsg: ''
   };
   private componentRef1: ComponentRef<{}>;
   private componentRef2: ComponentRef<{}>;
   private loading: boolean;
   private spacer = 20 + 38; // docList padding 20px + .content-container padding-bottom 38px
   private path: string;
   private movedialog: MatDialogRef<MoveDialogComponent>;
   private progress_dlg: MatDialogRef<UploadFilesComponent>;
   private version_dlg: MatDialogRef<VersionHistoryComponent>;
   private signDoc: MatDialogRef<SignDialogComponent>;
   private newFlow: MatDialogRef<NewTaskComponent>;
   public dataFolder: any;
   public paths: any[] = [];
   types: any[];
   items: any[] = [];
   info: any;
   activeItem: any;
   selectedTab: number;
   saveText = 'Save';
   hasMore: boolean;
   form: any;
   previewLoaded = false;
   extention = '';
   isBusiness: boolean;
   item: any;
   object_file: any;
   selectFile: any;
   shiftPressed = false;
   action_status = true;
   collapseInfo: boolean;
   user: any;
   comment: any;
   crl: boolean;
   sourceItem: any;
   post = 'ส่ง';
   permMove = true;
   corporatePath: string;
   nativeElement: any;
   isCheck: any;
   isDrag = false;
   permissionLevel = 0;
   private isDataDownload: any;
   private isDownloadFile: any;
   private waterMarkBtn: any;
   watermark: any;
   isMajor: any;
   isMinor: any;
   annoBtn: any;
   xmlAnno: any;
   webViewInstance: any;
   hide = false;
   eform: boolean;
   constructor(private router: Router, public service: IdexService, private upload: UploadService,
               private onedrive: OneDrive, private resolver: ComponentFactoryResolver, public dialog: MatDialog,
               private translate: TranslateService, private toast: Toast, private sanitizer: DomSanitizer,
               private app: AppComponent, private elementRef: ElementRef, private zone: NgZone, private googleAnalyticsService:GoogleAnalyticsService,
               private socialLogin: SocialLogin) {
      this.user = this.service.user;
      this.nativeElement = this.elementRef.nativeElement;
      this.translate.get('send').subscribe(s => {
         this.post = s;
      });
      this.translate.get('save').subscribe(s => {
         this.saveText = s;
      });
      this.translate.get('main.tasksDraft').subscribe(response => {
         this.taskStatusMessage.draftMsg = response;
      });
      this.translate.get('icon.signedSuccess').subscribe(response => {
         this.taskStatusMessage.completeMsg = response;
      });
      this.translate.get('icon.taskStartFlow').subscribe(response => {
         this.taskStatusMessage.waitMsg = response;
      });
      this.translate.get('icon.tasksReject').subscribe(response => {
         this.taskStatusMessage.rejectMsg = response;
      });
      this.translate.get('icon.taskDeleted').subscribe(response => {
         this.taskStatusMessage.deleteMsg = response;
      });
   }

   onDragStart(event, item) {
      if (!this.trash && !this.shared) {
         event.dataTransfer.setData('data', item);
         this.isDrag = true;
         item.selected = true;
         const index = this.selectedItems.indexOf(item);
         if (item.selected) {
            if (index === -1) {
               this.selectedItems.push(item);
            }
         }
         // The dataTransfer.setData() method sets the data type and the value of the dragged data
         this.sourceItem = item;

         // Change the opacity of the draggable element
         // event.target.style.opacity = '0.4';
         this.selectedItems.forEach(o => {
            $('#list_' + o.id)[0].style.opacity = '0.4';
         });

         this.permMove = true;
         for (const itemSel of this.selectedItems) {
            if (!(itemSel.permissions.write && itemSel.permissions.delete)) {
               this.permMove = false;
               break;
            }
         }

         if (this.permMove) {
            event.dataTransfer.effectAllowed = 'move';
         } else {
            event.dataTransfer.effectAllowed = 'none';
         }
      } else {
         event.dataTransfer.effectAllowed = 'none';
         event.dataTransfer.dropEffect = 'none';
      }
   }

   onDragOver(event) {
      if (this.isDrag) {
         event.preventDefault();
         event.stopPropagation();
         const arrToEle = event.target.id.split('_');
         const toEle = arrToEle.length > 1 ? arrToEle[1] : '';
         const item = this.items.find(function (obj) {
            return obj.id === toEle;
         });
         if (item && item.isFolder) {
            if (this.permMove) {
               let isSame = false;
               this.selectedItems.forEach(o => {
                  if (toEle === o.id) {
                     isSame = true;
                  }
               });

               if (!isSame) {
                  event.dataTransfer.dropEffect = 'move';

                  $('#img_' + toEle)[0].src = 'assets/icons/move_to_folder.png';
                  $('#list_' + toEle)[0].style.opacity = '0.7';
                  $('#list_' + toEle)[0].style.backgroundColor = 'rgba(0,178,201,0.05)';
                  $('#list_' + toEle)[0].style.borderColor = 'rgba(26,89,118,0.1)';

               } else {
                  event.dataTransfer.dropEffect = 'none';
               }
            } else {
               event.dataTransfer.dropEffect = 'none';
            }
         } else {
            event.dataTransfer.dropEffect = 'none';
         }
      }
      return false;
   }

   onDragLeave(event) {
      if (this.isDrag) {
         $.each($('img[src="assets/icons/move_to_folder.png"]'), function () {
            const arrImgId = $(this).attr('id').split('_');
            const imgId = arrImgId.length > 1 ? arrImgId[1] : '';
            $('#list_' + imgId).removeAttr('style');
            $(this).attr('src', 'assets/icons/folder.svg');
         });
      }
   }

   onDragEnd(event) {
      if (this.isDrag) {
         // Change the opacity of the draggable element
         this.selectedItems.forEach(o => {
            $('#list_' + o.id).removeAttr('style');
         });

         $.each($('img[src="assets/icons/move_to_folder.png"]'), function () {
            const arrImgId = $(this).attr('id').split('_');
            const imgId = arrImgId.length > 1 ? arrImgId[1] : '';
            $('#list_' + imgId).removeAttr('style');
            $(this).attr('src', 'assets/icons/folder.svg');
         });

         this.isDrag = false;
      }
   }

   onDrop(event) {
      if (this.isDrag) {
         if (event.stopPropagation) {
            event.stopPropagation(); // Stops some browsers from redirecting.
         }
         this.selectedItems.forEach(o => {
            $('#list_' + o.id).removeAttr('style');
         });
         const arrToEle = event.target.id.split('_');
         const toEle = arrToEle.length > 1 ? arrToEle[1] : '';
         $('#list_' + toEle).removeAttr('style');
         const item = this.items.find(function (obj) {
            return obj.id === toEle;
         });

         let pathTmp = this.path === '/' ? '' : this.path;
         let pathMove = this.path === undefined ? item.name : pathTmp + '/' + item.name;
         if (this.corporatePath === 'rootPath') {
            pathMove = item.name;
         }
         if (item && item.isFolder) {
            if (this.search) {
               this.path = item.path;
               pathTmp = this.path === '/' ? '' : this.path;
               pathMove = pathTmp + '/' + item.fileName;
            }
            $('#img_' + toEle)[0].src = 'assets/icons/folder.svg';

            let notMove = false;

            const listIds = [];
            if (this.selectedItems) {
               for (const itemSel of this.selectedItems) {
                  listIds.push(itemSel.id);
                  if (toEle === itemSel.id) {
                     notMove = true;
                     break;
                  }
               }
            }

            this.service.multipleMove(listIds, toEle, '','','')
               .subscribe(data => {
                     if (notMove) {
                        this.translate.get('alert.cant_move').subscribe(s => {
                           this.toast.error(s);
                        });
                     } else {
                        if (data.overallSuccess) {
                           this.selectedItems = [];
                           if (this.search) {
                              this.searchpos.emit(0);
                              this.loadmore.emit();
                           } else {
                              this.showdocument.emit();
                           }
                           this.translate.get('alert.multi_move_to').subscribe(s => {
                              this.toast.success(s + pathMove);
                           });
                        } else {
                           for (const i of data.results) {
                              if (i.fileExist) {
                                 this.translate.get('alert.cant_move_exist').subscribe(s => {
                                    this.toast.error(s);
                                 });
                                 break;
                              }
                           }
                        }
                     }
                  }
               );
         }
         this.isDrag = false;
      }
   }

   ngOnInit(): void {
      this.items = undefined;

      this.service.listTypes().subscribe(data => {
         this.types = data;
      });
      window.addEventListener('message', () => {
         if (this.onedrive.action === 'view') {
            if (this.action_status) {
               this.action_status = false;
            }
         }
      });
      this.service.role = this.role;
      this.getWatermark();
   }

   getWatermark() {
      this.service.getWatermark('Web').subscribe((data) => {
         this.watermark = data;
      });
   }

   ngOnDestroy() {
      if (this.componentRef1) {
         this.componentRef1.destroy();
      }
      if (this.componentRef2) {
         this.componentRef2.destroy();
      }
   }

   @HostListener('window:resize')
   onResize() {
      this.collapseInfo = window.innerWidth < 900;
      const header = $('.doc-header');
      if (header.length === 0) {
         return;
      }
      header.css({width: $('.doclist').outerWidth(true)});
   }

   setItems(items: any[], hasMore: boolean, metaFolder?: any) {
      this.items = items;
      this.hasMore = hasMore;
      this.loading = false;
      this.activeItem = undefined;
      this.dataFolder = metaFolder;
      setTimeout(() => {
         this.onWindowScroll();
      }, 100);
   }

   addItems(items: any[], hasMore: boolean) {
      if (items && items.length > 0) {
         this.items.push.apply(this.items, items);
      }
      this.hasMore = hasMore;
      this.loading = false;
   }

   canEdit(item: any): boolean {
      return Mimetype.canEdit(item);
   }

   getIcon(item: any): string {
      return Mimetype.getIcon(item, this.trash);
   }

   getIconTaskStatus(item: any): string {
      switch (item.statusDocument) {
         case 'Draft':
            return 'assets/icons/task_draft_color.svg';
         case 'Need to sign':
            return 'assets/icons/task_sign_color.svg';
         case 'Waiting for sign':
            return 'assets/icons/task_pending_color.svg';
         case 'Waiting for others':
            return 'assets/icons/task_sign_wait_color.svg';
         case 'Waiting':
            return 'assets/icons/workflow.svg';
         case 'Reject':
            return 'assets/icons/workflow_rejected.svg';
         case 'Completed':
            return 'assets/icons/task_completed.svg';
         case 'Deleted':
            return 'assets/icons/trash.svg';
      }
   }

   hasThumbnail(item: any) {
      return Mimetype.hasThumbnail(item, this.trash);
   }

   hasPreview(): boolean {
      return !this.info.isFolder && Mimetype.hasPreview(this.info.mimeType);
   }

   openItem(event: Event, item: any) {
      event.stopPropagation();
      const isShowStartFlow = !this.checkEForm(item) && (this.isStartFlowForm(item) || this.canSign(item)) && this.isStartFlow(item) && !this.shared && !this.sharedbyme;
      sessionStorage.setItem('isShowStartFlow', isShowStartFlow.toString());
      this.clickitem.emit(item);
   }

   getDeleted(item: any): any {
      const fmt = new MomentPipe();
      return {
         deleted: fmt.transform(item.deleted),
         user: item.deleter.name
      };
   }

   transform(value) {
      return this.sanitizer.bypassSecurityTrustHtml(value);
   }

   /**
    *
    * @detail : When key down on keyboard 'A' button thumbnails will be selected all button
    * and when key down on keyboard 'D' button thumbnails will be unselected all button.
    */

   @HostListener('document:keydown', ['$event'])
   onKeyDown(e: KeyboardEvent) {
      if (e.shiftKey) {
         this.shiftPressed = true;
      } else if (e.key === 'a' && (e.ctrlKey || e.metaKey)) {
         if (this.canDrag) {
            e.preventDefault();
            e.stopPropagation();
            this.items.forEach(o => {
               o.selected = true;
               const index = this.selectedItems.indexOf(o);
               if (index === -1) {
                  this.selectedItems.push(o);
               }
            });
         }
      } else if (e.key === 'd' && (e.ctrlKey || e.metaKey)) {
         if (this.canDrag) {
            e.preventDefault();
            e.stopPropagation();
            this.items.forEach(o => {
               o.selected = false;
               const index = this.selectedItems.indexOf(o);
               if (index !== -1) {
                  this.selectedItems.splice(index, 1);
               }
            });
            if (this.activeItem) {
               this.activeItem = this.info = undefined;
            }
         }
      }
   }

   @HostListener('document:keyup', ['$event'])
   onKeyUp(e: KeyboardEvent) {
      if (e.shiftKey) {
         this.shiftPressed = false;
      }
   }

   onItemSelect(event: any, item: any) {
      event.preventDefault();
      this.isCheck = true;
      item.selected = !item.selected;
      const index = this.selectedItems.indexOf(item);
      if (item.selected) {
         if (index === -1) {
            this.selectedItems.push(item);
         }
      } else {
         if (index !== -1) {
            this.selectedItems.splice(index, 1);
         }
      }
   }

   onItemClickMenu(event: any, item: any) {
      event.preventDefault();
      this.isCheck = false;
      this.eform = false;
      this.items.forEach(o => {
         o.selected = false;
         const indexDel = this.selectedItems.indexOf(o);
         if (indexDel !== -1) {
            this.selectedItems.splice(indexDel, 1);
         }
      });
      item.selected = true;
      if (this.selectedItems.indexOf(item) === -1) {
         this.selectedItems.push(item);
      }
      if (item.info === undefined || item.info === null) {
         this.service.getDocument(item.id).subscribe(data => {
            if (data.watermark !== null) {
               this.watermark = data.watermark;
            }
            if (data.permissions.eform){
               for (let i = 0; i < this.user.business.length; i++) {
                  if (this.user.business[i].role === 'Editor') {
                     if (this.user.business[i].tin === this.tin) {
                        this.eform = true;
                        break;
                     }
                  }
               }
            }
         });
      }
   }

   onItemClick(event: any, item: any) {
      event.preventDefault();
      if (this.shared) {
         this.permissionLevel = item.permissionLevel;
      }
      if (event.ctrlKey || event.metaKey) {
         this.isCheck = false;
         item.selected = !item.selected;
         const index = this.selectedItems.indexOf(item);
         if (item.selected) {
            if (index === -1) {
               this.selectedItems.push(item);
            }
         } else {
            if (index !== -1) {
               this.selectedItems.splice(index, 1);
            }
         }

         if (this.activeItem) {
            if (!this.activeItem.selected) {
               this.activeItem = this.info = undefined;
            }
            let active;
            for (const o of this.items) {
               if (o.selected) {
                  if (active) {
                     return;
                  }
                  active = o;
               }
            }
            if (active) {
               this.activeItem = active;
               this.loadInfo(active);
            }
            return;
         }
      } else if (event.shiftKey) {
         event.preventDefault();
         let from = this.activeItem ? this.items.indexOf(this.activeItem) : 0;
         let to = this.items.indexOf(item);
         if (to < from) {
            const x = from;
            from = to;
            to = x;
         }
         for (let i = 0; i < this.items.length; i++) {
            this.items[i].selected = i >= from && i <= to;
            if (this.items[i].selected) {
               if (this.selectedItems.indexOf(this.items[i]) === -1) {
                  this.selectedItems.push(this.items[i]);
               }
            }
         }
         this.isCheck = false;
         if (from !== to) {
            return;
         }
      } else if (this.activeItem === item) {
         if (!this.isCheck) {
            this.items.forEach(o => {
               if (o !== this.activeItem) {
                  o.selected = false;
                  const indexDel = this.selectedItems.indexOf(o);
                  if (indexDel !== -1) {
                     this.selectedItems.splice(indexDel, 1);
                  }
               }
            });
            item.selected = true;
            if (this.selectedItems.indexOf(item) === -1) {
               this.selectedItems.push(item);
            }
         }
         this.isCheck = false;
         return;
      } else {
         if (!this.isCheck) {
            this.items.forEach(o => {
               o.selected = false;
               const indexDel = this.selectedItems.indexOf(o);
               if (indexDel !== -1) {
                  this.selectedItems.splice(indexDel, 1);
               }
            });
            item.selected = true;
            if (this.selectedItems.indexOf(item) === -1) {
               this.selectedItems.push(item);
            }
         }
      }

      this.info = undefined;
      this.previewLoaded = false;
      if (this.selectedItems.length <= 1) {
         this.activeItem = item;
         this.loadInfo(item);
      }
      this.isCheck = false;
   }

   loadInfo(item: any) {
      if (item.info) {
         this.showInfo(item.info);
      } else {
         let getDocument: Observable<zDoxItem>;
         if (this.trash) {
            getDocument = this.service.getDeleteDocument(item.id);
         } else {
            getDocument = this.service.getDocument(item.id);
         }
         getDocument.subscribe(data => {
            if (this.activeItem.id !== data.id) {
               return;
            } // too late, just ignore it!
            if (this.trash) {
               data.description = data.description || '-';
            }
            this.showInfo(item.info = data);
            this.form = undefined; // clear form
         });
      }
   }

   share(item: any) {
      this.googleAnalyticsService.trackEvent("zdox-share",{event_page: 'dms',event_label: 'share',event_action: 'share'});

      const dialogRef = this.dialog.open(SharingComponent, {
         disableClose: true,
         data: {
            id: item.id,
            name: this.search ? item.fileName : item.name,
            description: item.description,
            service: this.service,
            component: this,
            toast: this.toast,
            role: this.role,
            item: item,
            tin: this.tin,
            isSite: item.isSite ? item.isSite : !(this.tin === undefined || this.tin === ''),
            isDisabled: this.sharedwithme,
            myFile: this.myfile
         }
      });
      dialogRef.afterClosed().subscribe(result => {
         if (result) {
            if (!item.shared && this.sharedbyme) {
               const i = this.items.indexOf(item);
               if (i !== -1) {
                  this.selectedItems.forEach(o => {
                     const indexDel = this.items.indexOf(o);
                     if (indexDel !== -1) {
                        this.items[indexDel].selected = false;
                     }
                     this.selectedItems.splice(0, 1);
                  });
                  this.items.splice(i, 1);
               }
               if (this.activeItem === item) {
                  this.activeItem = undefined;
                  if (this.path) {
                     this.loadPathInfo(this.path);
                  } else {
                     this.info = undefined;
                  }
               }
            }
         }
      });
   }

   checkAnnotation(item: any, docUrl: any, canTransform: any, downloadUrl: any) {

      const fileName = item.name.split('.')[0] + '.pdf';

      let webViewerOptions: WebViewerOptions = {
         licenseKey: environment.pdfTronKey.toString(),
         path: '../assets/lib',
         fullAPI: true,
         enableAnnotations: true,
         filename: fileName,
      };
      const viewerTempUrl = docUrl.toString();
      if (item.mimeType === 'image/jpeg' || item.mimeType === 'image/png') {
         webViewerOptions.loadAsPDF = true;
         WebViewer(webViewerOptions, this.viewerRef.nativeElement).then(async instance => {
            const { UI, Core } = instance;
            const { documentViewer } = Core;
            const annotMana = documentViewer.getAnnotationManager();
            UI.loadDocument(docUrl.toString(), { documentId: '1', filename: item.name });
            documentViewer.addEventListener('documentLoaded', async () => {
               await annotMana.importAnnotations(this.xmlAnno);
               this.openPopup(canTransform, instance, item, downloadUrl);
            });
         });
      } else if (item.mimeType === 'image/tiff') {
         WebViewer(webViewerOptions, this.viewerRef.nativeElement).then(async instance => {
            const { Core } = instance;
            const { documentViewer } = Core;
            const annotMana = documentViewer.getAnnotationManager();
            const PDFNet = instance.Core.PDFNet;
            documentViewer.addEventListener('documentLoaded', async () => {
               await annotMana.importAnnotations(this.xmlAnno);
               this.openPopup(canTransform, instance, item, downloadUrl);
            });
            let newDoc: Core.PDFNet.PDFDoc;
            await PDFNet.runWithoutCleanup(async function () {
               const doc = await PDFNet.PDFDoc.create();
               newDoc = doc;
               await newDoc.initSecurityHandler();
               await newDoc.lock();
               const tiffFile = await PDFNet.Filter.createURLFilter(viewerTempUrl);
               await PDFNet.Convert.fromTiff(newDoc, tiffFile);
               await newDoc.unlock();
               instance.UI.loadDocument(newDoc);
            }, environment.pdfTronKey.toString()).then(() => {
            });
         });
      } else {
         webViewerOptions.initialDoc = `${docUrl.toString()}`;
         WebViewer(webViewerOptions, this.viewerRef.nativeElement).then(async instance => {
            const { Core } = instance;
            const { documentViewer } = Core;
            const annotMana = documentViewer.getAnnotationManager();
            documentViewer.addEventListener('documentLoaded', async () => {
               await annotMana.importAnnotations(this.xmlAnno);
               this.openPopup(canTransform, instance, item, downloadUrl);
            });
         });
      }
   }

   private openPopup(canTransform: boolean, instance: WebViewerInstance, item: any, downloadUrl: any) {
      if (!this.watermark && !this.xmlAnno) {
         canTransform = false;
      }
      if (canTransform) {
         this.zone.run(() => {

            let titleDialog = '';

            this.translate.get('Watermark').subscribe(s => {
               this.waterMarkBtn = s;
            });

            this.translate.get('Annotation').subscribe(s => {
               this.annoBtn = s;
            });

            this.translate.get('Download-dialog').subscribe(s => {
               titleDialog = s;
            });
            let dataOption = {
               list: [],
               title: titleDialog
            };
            if (this.xmlAnno && this.watermark) {
               dataOption = {
                  list: [{id: 1, selected: false, name: this.annoBtn},
                     {id: 2, selected: false, name: this.waterMarkBtn}],
                  title: titleDialog
               };

            } else if (this.xmlAnno && !this.watermark) {
               dataOption = {
                  list: [{id: 1, selected: false, name: this.annoBtn}],
                  title: titleDialog
               }

            } else if (!this.xmlAnno && this.watermark) {
               dataOption = {
                  list: [{id: 2, selected: false, name: this.waterMarkBtn}],
                  title: titleDialog
               };
            }
            const dialogRef = this.dialog.open(DownloadListComponent, {
               data: dataOption
            });
            const dialogSubmit = dialogRef.componentInstance.submitData.subscribe(result => {
               this.isDataDownload = result;
               dialogSubmit.unsubscribe();
            });

            dialogRef.afterClosed().subscribe(async res => {
               this.isDownloadFile = res;
               if (this.isDownloadFile) {
                  let isWatermark = false;
                  if (this.isDataDownload.length === 2) {

                     if (this.watermark) {
                        isWatermark = this.isDataDownload[1].selected;
                     }
                     await this.setDownload(this.isDataDownload[0].selected, isWatermark, instance, item);

                  } else if (this.isDataDownload.length === 1){

                     if (this.isDataDownload[0].selected) {
                        if (this.watermark) {
                           await this.setDownload(false, true, instance, item);
                        }
                        if (this.xmlAnno) {
                           await this.setDownload(true, false, instance, item);
                        }
                     } else {
                        location.href = downloadUrl;
                        instance.UI.dispose();
                     }

                  } else {
                     location.href = downloadUrl;
                     instance.UI.dispose();
                  }

               } else {
                  instance.UI.dispose();
                  this.xmlAnno = '';
               }
            });
         });
      } else {
         this.service.post('audit/download').subscribe(() => {
         }, (err) => {
            console.error(err);
         });
         location.href = downloadUrl;
         instance.UI.dispose();
         this.xmlAnno = '';
      }
   }

   async setDownload(incAnno, incWatermark, instance, item) {

      if (incWatermark) {
         this.setWatermarkDownload(instance).then(async a => {
            await instance.UI.downloadPdf({
               filename: item.name.split('.')[0] + '.pdf',
               includeAnnotations: incAnno,
            }).then(b => {
               instance.UI.dispose();
               this.xmlAnno = '';
            });
         });
      } else {
         await instance.UI.downloadPdf({
            filename: item.name.split('.')[0] + '.pdf',
            includeAnnotations: incAnno,
            flatten: true,
         }).then(() => {
            instance.UI.dispose();
            this.xmlAnno = '';
         });
      }

      this.service.post('audit/download').subscribe(() => {
      }, (err) => {
         console.error(err);
      });

   }

   async setWatermarkDownload(ins: WebViewerInstance) {
         if (this.watermark) {
            const {PDFNet} = ins.Core;
            await PDFNet.initialize();

            const totalPage = ins.Core.documentViewer.getDocument().getPageCount();
            const doc = await ins.Core.documentViewer.getDocument().getPDFDoc();

            await PDFNet.runWithCleanup(async () => {
               try {
                  const s = await PDFNet.Stamper.create(PDFNet.Stamper.SizeType.e_font_size, this.watermark.fontSize, 0);
                  await s.setAlignment(PDFNet.Stamper.HorizontalAlignment.e_horizontal_center, PDFNet.Stamper.VerticalAlignment.e_vertical_center);
                  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(this.watermark.color);
                  const r = parseInt(result[1], 16);
                  const g = parseInt(result[2], 16);
                  const b = parseInt(result[3], 16);
                  const redColorPt = await PDFNet.ColorPt.init(r / 255, g / 255, b / 255, 0);
                  await s.setFontColor(redColorPt);
                  await s.setTextAlignment(PDFNet.Stamper.TextAlignment.e_align_center);
                  await s.setAsBackground(false);
                  await s.setOpacity(this.watermark.opacity / 100);
                  await s.setRotation(-45);
                  const pgSet = await PDFNet.PageSet.createRange(1, Number(totalPage));
                  await s.stampText(doc, this.watermark.text, pgSet);
               } catch (err){
                  console.log('err = ', err);
               }
               }, environment.pdfTronKey.toString()
            );
         }
   }

   async download(item: any) {
      if (item.isFolder) {
         this.dialog.open(DownloadFolderComponent, {
            disableClose: true,
            data: {
               id: item.id,
               name: item.name,
               service: this.service
            }
         });

         this.googleAnalyticsService.trackEvent("zdox-download",{event_page: 'dms',event_label: 'download-folder',event_action: 'dowload'});
      } else {
         let annotationId = '';
         let annotationVersion = '';

         const annotationAttributes = await this.service.getAnnotation(item.id, false).toPromise();

         if (annotationAttributes) {

            annotationVersion = annotationAttributes.annotationVersion;
            annotationId = annotationAttributes.annotationId;

            this.service.getContentAnnotation(annotationId, annotationVersion).subscribe(async annotationContent => {
               if (annotationContent !== null) {
                  this.xmlAnno = annotationContent;
               }
            });
         }

         const token = this.service.user.token;
         const url = this.service.url + '/content?id=' + item.id + '&token=' + token;
         const docUrl = url + '&isPdfTron=true&' + Date.now();
         const downloadUrl = this.service.downloadFileUrl(item.id) + '&token=' + this.service.user.token;

         const mimeType = item.mimeType;
         const canTransform = (mimeType != null
            && (mimeType === 'application/pdf'
               || mimeType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
               || mimeType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
               || mimeType === 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
               || mimeType === 'application/vnd.oasis.opendocument.text'
               || mimeType === 'image/tiff'
               || mimeType === 'image/tif'
               || mimeType === 'image/jpeg'
               || mimeType === 'image/png'
               || mimeType === 'application/msword'
               || mimeType === 'application/vnd.ms-excel'
               || mimeType === 'application/vnd.ms-powerpoint'));
         if (mimeType === 'text/xml' || mimeType === 'application/octet-stream') {
            location.href = downloadUrl;
         } else {
            this.checkAnnotation(item, docUrl, canTransform, downloadUrl);
         }


         this.googleAnalyticsService.trackEvent("zdox-download",{event_page: 'dms',event_label: 'download-file',event_action: 'dowload'});
      }

   }

   getVersion(item: any): string {
      if (item.version.substring(item.version.length - 2) === '.0') {
         return 'v' + item.version.substring(0, item.version.length - 2);
      }
      return 'v' + item.version;
   }

   loadPathInfo(path: string, tin?: string) {
      this.path = path;
      this.tin = tin !== undefined ? tin : this.tin;
      this.service.getInfo(path, this.tin)
         .subscribe(data => {
            this.showInfo(data);
         });
   }

   private showInfo(data: zDoxItem) {
      this.comment = data.comments;
      this.info = data;
      const noMetadata = this.selectedTab === undefined || data.isFolder || (this.trash && !data.typeName);
      this.selectTab(noMetadata ? 0 : this.selectedTab);
      setTimeout(() => {
         if (!this.trash && data.properties) {
            this.componentRef1 = DocTypeComponent.create(this.resolver, this.componentRef1, this.form1, data.properties);
         }
         this.updateContainerHeight();
      }, 200);
   }

   private updateContainerHeight() {
      setTimeout(() => {
         let infoTitle = $('.info-title');
         if (this.shared) {
            infoTitle = $('.info-title-share');
         }
         const height = $('.info-body:visible').outerHeight(true) + infoTitle.outerHeight(true);
         this.adjustInfoPosition();
      }, 100);
   }

   selectTab(index: number) {
      this.selectedTab = index;
      setTimeout(() => {
         const e = $('.title-label:eq(' + index + ')');
         if (e.length > 0) {
            $('.indicator').css({left: e.position().left, width: e.outerWidth(true)});
         }
         if (this.descElement) {
            this.descElement.nativeElement.value = this.info.description || '';
         }
         this.adjustInfoPosition();
      }, 100);
   }

   saveDescription(event: Event, doc: any): void {
      const input = <HTMLTextAreaElement>event.target;
      const value = input.value;
      if (value !== doc.description) {
         this.service.updateDescription(value, doc.id)
            .subscribe(() => {
               doc.description = value;
               this.loadInfo(doc);
            });
      }

   }

   @HostListener('window:scroll')
   onWindowScroll() {
      if (this.hasMore && !this.loading) {
         if (window.innerHeight + window.pageYOffset + 1 >= document.body.scrollHeight) {
            this.loading = true;
            this.loadmore.emit();
         }
      }

      this.adjustInfoPosition();
   }

   private adjustInfoPosition() {
      const info = $('.info-body:visible');
      if (info.length === 0) {
         return;
      }

      let title = $('.info-title');
      if (this.shared) {
         title = $('.info-title-share');
      }
      const infoTop = title.position().top + title.outerHeight(true);
      const top = infoTop + 'px';
      if (window.scrollY > 0) {
         // TODO: detect scroll direction and use to calc position instead of window.scrollY
         const height = info.outerHeight(true);
         if (window.innerHeight - infoTop - height < 0) {
            const x = window.innerHeight - this.spacer;
            let y = infoTop - window.scrollY;
            if (y + height < x) {
               y = x - height;
            }
         }
      }
   }

   postComment(button: MatButton, input: any): void {
      const text = input.value.trim();
      if (text.length === 0) {
         input.focus();
         return;
      }
      button.disabled = true;
      this.translate.get('sending').subscribe(s => {
         this.post = s;
      });

      this.service.postComment(this.info.id, text).subscribe(
         () => {
            input.value = '';
            this.translate.get('sended').subscribe(s => {
               this.post = s;
            });
            this.getComment();
            setTimeout(() => {
               button.disabled = false;
               this.translate.get('send').subscribe(s => {
                  this.post = s;
               });
            }, 3000);
         },
         error => {
            button.disabled = false;
            this.translate.get('send').subscribe(s => {
               this.post = s;
            });
         });
   }

   getComment(): void {
      this.service.getComment(this.info.id).subscribe(
         data => {
            this.comment = data.items;
            this.info.comments = data.items;
         });
   }

   beginRename(item: any) {
      this.resetRename();
      this.canDrag = false;
      item.editing = true;
      setTimeout(() => {
         const input = $('#edit-' + item.id).focus()[0];
         let i;
         if (!item.isFolder) {
            i = item.name.lastIndexOf('.');
            if (i === -1) {
               i = item.name.length;
            } else {
               this.extention = item.name.split('.')[item.name.split('.').length - 1];
               item['type'] = this.extention;
            }
         } else {
            i = item.name.length;
         }
         const fileName = item.name.slice(0, i);
         item.name = fileName;
         if (input.setSelectionRange) {
            input.setSelectionRange(0, i);
         } else if (input.createTextRange) {
            const range = input.createTextRange();
            range.collapse(true);
            range.moveEnd('character', i);
            range.moveStart('character', 0);
            range.select();
         } else if (input.selectionStart) {
            input.selectionStart = 0;
            input.selectionEnd = i;
         }
      }, 200);
   }

   endRename(item: any) {
      this.canDrag = true;
      item.editing = false;
      this.extention = '';
   }

   resetRename(){
      this.items.forEach(item_state => {
         if(item_state.editing){
            //reset Name old rename not finish
            item_state.name += "."+this.extention;
            this.endRename(item_state);
         }
      });
   }

   renameKeyDown(event: KeyboardEvent, item: any) {
      if (event.key === 'Enter') {
         $('#edit-' + item.id).trigger('blur');
      } else if (event.key === 'Escape') {
         $('#edit-' + item.id).val(item.name);
         this.endRename(item);
      }
   }

   rename(item: any) {
      const value = $('#edit-' + item.id).val().trim();
      if (value.length === 0) {
         return;
      } else if (item.name === value) {
         if (this.extention !== '' && this.extention !== undefined && !item.isFolder) {
            item.name += '.' + this.extention;
         }
         this.endRename(item);
      } else if (/[<|>\\\/:?*"]/g.test(value)) {
         this.translate.get('alert.create_folder_error').subscribe(s => {
            this.toast.error(s);
         });
         return;
      } else {
         let update;
         if (this.extention !== '' && this.extention !== undefined && !item.isFolder) {
            update = value + '.' + this.extention;
            this.service.rename(item.id, update)
               .subscribe(() => {
                  item.name = update;
                  this.endRename(item);
               });
         } else {
            if (item.isFolder && value.lastIndexOf('.') === value.length - 1) {
               this.translate.get('alert.create_folder_error_dot').subscribe(s => {
                  this.toast.error(s);
               });
            } else {
               update = value;
               this.service.rename(item.id, update)
                  .subscribe(() => {
                     item.name = update;
                     this.endRename(item);
                  });
            }
         }
      }
   }

   confirmDelete(item: any): void {
      if (item.startFlow && item.statusDocument !== 'Completed') {
         this.translate.get('alert.warning-task').subscribe(s => {
            this.toast.error(s);
         });
         return;
      } else if (item.startFlow && item.statusDocument === 'Completed') {
         this.translate.get('alert.warning-task-completed').subscribe(s => {
            this.toast.error(s);
         });
         return;
      }
      const dialogRef = this.dialog.open(ConfirmDeleteComponent, {
         disableClose: true,
         data: {service: this.service, item: item, toast: this.toast, translate: this.translate}
      });
      dialogRef.afterClosed().subscribe(result => {
         if (result) {
            const i = this.items.indexOf(item);
            if (i !== -1) {
               this.selectedItems.forEach(o => {
                  const indexDel = this.items.indexOf(o);
                  if (indexDel !== -1) {
                     this.items[indexDel].selected = false;
                  }
                  this.selectedItems.splice(0, 1);
               });
               this.items.splice(i, 1);
            }
            if (this.activeItem === item) {
               this.activeItem = undefined;
               if (this.path) {
                  this.loadPathInfo(this.path);
               } else {
                  this.info = undefined;
               }
            }
         }
      });
   }

   loadForm(option: any) {
      this.form = undefined;
      this.service.getType(option.value).subscribe(data => {
         this.form = data;
         this.componentRef2 = DocTypeComponent.create(this.resolver, this.componentRef2, this.form2, data);
         this.updateContainerHeight();
      });
   }

   navigate(path: string) {
      let tin;
      let url;
      if (!path.startsWith('/')) {
         const index = path.indexOf('/');
         if (index > 0) {
            const business = path.substr(0, index);
            const name = path.substr(index, path.length);
            for (let i = 0; i < this.user.business.length; i++) {
               if (this.user.business[i].name === business) {
                  tin = this.user.business[i].tin;
               }
            }
            url = Path.combine('/work', tin, name);
         } else {
            for (let i = 0; i < this.user.business.length; i++) {
               if (this.user.business[i].name === path) {
                  tin = this.user.business[i].tin;
               }
            }
            url = Path.combine('/work', tin);
         }

      } else {
         url = Path.combine('/files', path);
      }
      this.router.navigate([url]);
   }

   private getProperties(form: any[]) {
      const error = function (e, msg) {
         e.focus();
         return null;
      };
      const properties = {};
      for (const f of form) {
         const e = $('#' + f.name.replace(':', '_'));
         const value = e.val();
         if (f.mandatory && !value) {
            return error(e, f.label + ' is required');
         }
         if (f.constraints && value) {
            if (f.constraints.minLength && value.length < f.constraints.minLength) {
               return error(e, 'Minimum length of ' + f.label + ' is ' + f.constraints.minLength + ' characters');
            }
            if (f.constraints.maxLength && value.length > f.constraints.maxLength) {
               return error(e, 'Maximum length of ' + f.label + ' is ' + f.constraints.maxLength + ' characters');
            }
            if (f.constraints.minValue !== undefined && value < f.constraints.minValue) {
               return error(e, 'Minimum value of ' + f.label + ' is ' + f.constraints.minValue);
            }
            if (f.constraints.maxValue !== undefined && value > f.constraints.maxValue) {
               return error(e, 'Maximum value of ' + f.label + ' is ' + f.constraints.maxValue);
            }
            if (f.constraints.expression && !new RegExp(f.constraints.expression).test(value)) {
               return error(e, 'Value of ' + f.label + ' did not match the pattern');
            }
         }
         properties[f.name] = value;
      }
      return properties;
   }

   saveType(button: any, type: any) {
      const data = {type: type.value, properties: this.getProperties(this.form)};
      if (!data.properties) {
         return;
      }
      button.disabled = true;
      this.translate.get('saving').subscribe(s => {
         this.saveText = s;
      });
      this.service.setType(this.info.id, data).subscribe(value => {
         this.info.typeName = type.viewValue;
         this.info.properties = value;
         setTimeout(() => {
            this.componentRef1 = DocTypeComponent.create(this.resolver, this.componentRef1, this.form1, value);
            this.updateContainerHeight();
         }, 200);
         this.translate.get('saved').subscribe(s => {
            this.saveText = s;
         });
         setTimeout(() => {
            button.disabled = false;
            this.translate.get('save').subscribe(s => {
               this.saveText = s;
            });
         }, 5000);
      });
   }

   saveProperties(button: MatButton) {
      const properties = this.getProperties(this.info.properties);
      if (!properties) {
         return;
      }
      button.disabled = true;
      this.translate.get('saving').subscribe(s => {
         this.saveText = s;
      });
      this.service.setMetadata(this.info.id, properties).subscribe(data => {
         this.info.properties = data;
         this.translate.get('saved').subscribe(s => {
            this.saveText = s;
         });
         setTimeout(() => {
            button.disabled = false;
            this.translate.get('save').subscribe(s => {
               this.saveText = s;
            });
         }, 5000);
      });
   }

   confirmRestore(item: any) {
      const dialogRef = this.dialog.open(ConfirmRestoreComponent, {
         disableClose: true,
         data: {service: this.service, item: item, toast: this.toast, translate: this.translate}
      });
      dialogRef.afterClosed().subscribe(result => {
         if (result) {
            const i = this.items.indexOf(item);
            const j = this.selectedItems.indexOf(item);
            if (i !== -1) {
               this.selectedItems.splice(j, 1);
               this.items.splice(i, 1);
            }
            if (this.activeItem === item) {
               this.activeItem = undefined;
               this.info = undefined;
            }
         }
      });
   }

   confirmPermanentDelete(item: any): void {
      const dialogRef = this.dialog.open(ConfirmPermanentDeleteComponent, {
         disableClose: true,
         data: {service: this.service, item: item, toast: this.toast, translate: this.translate}
      });
      dialogRef.afterClosed().subscribe(result => {
         if (result) {
            const i = this.items.indexOf(item);
            const j = this.selectedItems.indexOf(item);
            if (i !== -1) {
               this.selectedItems.splice(j, 1);
               this.items.splice(i, 1);
            }
            if (this.activeItem === item) {
               this.activeItem = undefined;
               this.info = undefined;
            }
         }
      });
   }

   versionHistory(item: any) {
      this.version_dlg = this.dialog.open(VersionHistoryComponent, {
         disableClose: true,
         data: this
      });
      this.version_dlg.componentInstance.doc_id = item.id;
      this.version_dlg.componentInstance.items = item;
      this.version_dlg.componentInstance.shared = this.shared;
      this.version_dlg.componentInstance.translate = this.translate;
      this.version_dlg.componentInstance.toast = this.toast;
      this.version_dlg.componentInstance.tin = this.tin;
   }

   permission(item: any) {
      this.dialog.open(CorporatePermissionComponent, {
         disableClose: true,
         data: {data: this, item: item}
      });
   }

   openMove(item: any) {
      this.movedialog = this.dialog.open(MoveDialogComponent, {
         disableClose: true,
         data: {service: this.service, item: item, data: this, toast: this.toast, translate: this.translate}
      });
      this.movedialog.afterClosed().subscribe(result => {
         if (result) {
            const i = this.items.indexOf(item);
            if (i !== -1) {
               if (this.search) {
                  this.searchpos.emit(0);
                  this.loadmore.emit();
               } else {
                  this.items.splice(i, 1);
               }
            }
            if (this.activeItem === item) {
               this.activeItem = undefined;
               if (this.path) {
                  this.loadPathInfo(this.path);
               } else {
                  this.info = undefined;
               }
            }
         }
      });
   }

   openWith(item: any) {
      if (!item) {
         return;
      }
      if (!window.localStorage.getItem('access_token')) {
         this.item = item;
         this.action_status = true;
         this.onedrive.signIn('view');
         const loop = setInterval(() => {
            if (window.localStorage.getItem('access_token')) {
               clearInterval(loop);
               this.openWithOnedrive(item, window.localStorage.getItem('access_token'));
            }
         },2000);
      } else {
         this.openWithOnedrive(item, window.localStorage.getItem('access_token'));
      }
   }

   openWithGoogle(item: any) {
      let token = sessionStorage.getItem('access_token_google') as string;
      let mimeType;
      if (item.openWithGoogle === 'Google Sheets') {
         mimeType = 'spreadsheets';
      } else {
         mimeType = 'document';
      }
      const next = () => {
         token = sessionStorage.getItem('access_token_google') as string;
         const dialogRef = this.dialog.open(WaitForImportComponent, {disableClose: true, data: this});
         const waiting = dialogRef.componentInstance;
         waiting.path = this.path;
         this.translate.get('googleDoc.open').subscribe(s => {
            waiting.message = s;
         });

         this.service.openwith_google(item.id, token)
            .subscribe(data => {
               window.open('https://docs.google.com/' + mimeType + '/d/' + data.id + '/edit');
               waiting.progress = false;
               waiting.status = 'edit-drive';
               waiting.id = data.id;
               waiting.doc_id = item.id;
               waiting.name = item.name;
               this.translate.get('onedrive.save').subscribe(s => {
                  waiting.message = s;
               });
               this.translate.get('onedrive.saveText').subscribe(s => {
                  waiting.saveText = s;
               });
               waiting.update();
               waiting.isBusiness = this.isBusiness;
               waiting.access_token = token;
            });
      };
      if (token) {
         next();
      } else {
         this.socialLogin.withGoogle().subscribe(result => {
            next();
         }, error => {});
      }
   }

   onSelectFiles(input: any, item: any) {
      this.dialog.open(UploadNewVersionComponent, {
         disableClose: true,
         data : { 'item' : item,
                  'input' : input,
                  'uploadNewVersion': this.uploadNewVersion}});
   }

   onProgressLoad2(percen: any, count: any, file: any): void {
      file.percentage = percen;
      this.progress_dlg.componentInstance.progressBar_percentage(percen, count);

   }

   successUpload1(ans: any): void {
      setTimeout(() => {
         this.progress_dlg.close();
         this.showdocument.emit();
         this.upload.sum_count = 0;
         this.app.uploading = false;
         this.fileUpload.nativeElement.value = '';
      }, 1000);
   }

   // Sign-Off Document
   canSign(item: any): boolean {
      return Mimetype.canSign(item);
   }

   async openSign(item: any) {
      callWebview(item, 'sign-off', this.service, this.viewerRef.nativeElement, this.router, this.zone, this.loader);
   }

   async openStartFlow(item: any) {
      callWebview(item, 'create-task', this.service, this.viewerRef.nativeElement, this.router, this.zone, this.loader, this.paths, this.dataFolder, this.tin, this.isStartFlowForm(item));
   }

   delComment(item: any): void {
      const dialogRef = this.dialog.open(DeleteCommentComponent, {
         disableClose: true,
         data: {service: this.service, item: item}
      });
      dialogRef.afterClosed().subscribe(result => {
         if (result) {
            const i = this.comment.indexOf(item);
            if (i !== -1) {
               this.comment.splice(i, 1);
            }
         }
      });
   }

   editComment(item: any) {
      item.editing = true;
      setTimeout(() => {
         $('#textArea-' + item.id).focus();
      }, 200);
   }

   saveComment(item: any, input: any) {
      if (input.value.trim().length === 0) {
         return;
      }
      this.service.put('/comments/' + item.id + '/' + this.info.id, {content: encodeURIComponent(input.value)})
         .subscribe(res => {
            item.editing = false;
            item.content = input.value;
         });
   }

   errorImgHandler(event) {
      event.target.src = this.getIcon(this.info);
   }

   checkStatusTask(item, statusTask) {
      if (item.editing) {
         return false;
      } else {
         switch (statusTask) {
            case 'Draft' :
               return true;
            case 'Waiting' :
               return true;
            case 'Completed' :
               return true;
            case 'Reject' :
               return true;
            case 'Deleted' :
               return true;
            default:
               return false;
         }
      }
   }

   getStatusMessage(statusTask) {
      switch (statusTask) {
         case 'Draft':
            return this.taskStatusMessage.draftMsg;
         case 'Waiting' :
            return this.taskStatusMessage.waitMsg;
         case 'Reject' :
            return this.taskStatusMessage.rejectMsg;
         case 'Completed' :
            return this.taskStatusMessage.completeMsg;
         default :
            return '';
      }
   }

   isStartFlow(item) {
      if (item.startFlow) {
         if (item.statusDocument === 'Completed') {
            return true;
         } else {
            return false;
         }
      } else {
         return true;
      }
   }

   isStartFlowForm(item) {
      let extension;
      if (item.mimeType === 'application/octet-stream' || item.mimeType === 'text/xml') {
         extension = item.name.split('.')[item.name.split('.').length - 1];
         return extension && (extension === 'zdox') && item.permissions.write;
      }
      return false
   }

   checkEForm(item) {
      let extension;
      if (item.mimeType === 'application/octet-stream' || item.mimeType === 'text/xml') {
         extension = item.name.split('.')[item.name.split('.').length - 1];
         return extension && extension === 'zdox';
      }
      return false
   }

   onClickLink(item: any) {
      sessionStorage.setItem('taskPath', 'tasks/startFlow/' + item.id);
      this.router.navigate(['tasks/startFlow/', item.id], {replaceUrl: true});
   }

   saveDoc(isInsert: any) {
      if (isInsert !== undefined) {
         if (isInsert.checkAnno) {
            let createdBy;
            this.service.getAnnotation(isInsert.docId, true).subscribe(data => {
               if (data !== null) {
                  createdBy = data.createdBy;
               }
            });
            this.service.insertDataToDatabase(isInsert.docId, isInsert.annotationId, isInsert.annotationVersion, createdBy).subscribe(suss => {});
         }
      }
   }

   duplicate(item: any){
      const listIds = [];
      listIds.push(item.id);
      this.service.duplicateDoc(listIds)
         .subscribe(data => {
            this.showdocument.emit();
            this.translate.get('alert.duplicate_complete').subscribe(s => {
            this.toast.success(item.name +" "+ s);
            if (this.path) {
               this.loadPathInfo(this.path);
            } else {
               this.info = undefined;
            }
            });
         });
   }

   isZdoxFile(item: any): boolean {
      if (item.isFolder) {
         return false;
      }
      let ext = item?.name?.split('.').pop();
      return ext.toLowerCase() === 'zdox';
   }

   openWithOnedrive(item, token){
      const dialogRef2 = this.dialog.open(WaitForImportComponent, {disableClose: true, data: this});
      const waiting = dialogRef2.componentInstance;
      waiting.path = this.path;
      this.translate.get('onedrive.open').subscribe(s => {
         waiting.message = s;
      });
      this.service.openwith_onedrive(item.id, token).subscribe(data => {
         if(data.webUrl){
            window.open(data.webUrl, '_blank');
            waiting.progress = false;
            waiting.status = 'edit';
            waiting.id = data.id;
            waiting.doc_id = item.id;
            waiting.name = data.name;
            this.translate.get('onedrive.save').subscribe(s => {
               waiting.message = s;
            });
            this.translate.get('onedrive.saveText').subscribe(s => {
               waiting.saveText = s;
            });
            waiting.isBusiness = this.isBusiness;
            waiting.update();
         }else{
            this.findItemAndOpenWithOnedrive(token, item, waiting);
         }
      }, error2 => {
         if (error2.status === 401 || (error2.status === 500 && error2.message === 'Stream closed')) {
            this.item = item;
            dialogRef2.close();
            this.action_status = true;
            localStorage.removeItem('access_token');
            this.onedrive.signIn('view');
         } else if (error2.status === 409) {
            this.findItemAndOpenWithOnedrive(token, item, waiting);
         } else {
            dialogRef2.close();
            this.toast.error(error2.message);
         }
      });
   }

   findZdoxFolderOnOnedrive(token): Promise<any> {
      return new Promise((resolve, reject) => {
         let apps;
         let zdox;
         this.service.onedriveFolders(token).subscribe((res) => {
            apps = res.value.find(e => e.name === 'Apps');
            this.service.onedriveFolders(token, 50, apps.id).subscribe((res) => {
               zdox = res.value.find(e => e.name === 'zDox');
               resolve(zdox.id);
            }, (error) => {
               reject(error);
            });
         }, (error) => {
            reject(error);
         });
      });
   }

   async findItemAndOpenWithOnedrive(token, item, waiting){
      try {
         let zDoxFolder = await this.findZdoxFolderOnOnedrive(token);
         this.service.onedriveListItems(token, zDoxFolder, 50, item.name).subscribe((res) => {
            const resItem = res.value.find(e => e.name === item.name);
            window.open(resItem.webUrl, '_blank');
            waiting.progress = false;
            waiting.status = 'edit';
            waiting.id = resItem.id;
            waiting.doc_id = item.id;
            waiting.name = resItem.name;
            this.translate.get('onedrive.save').subscribe(s => {
               waiting.message = s;
            });
            this.translate.get('onedrive.saveText').subscribe(s => {
               waiting.saveText = s;
            });
            waiting.isBusiness = this.isBusiness;
            waiting.update();
         })
      } catch (error) {
      }
   }
}

async function callWebview(item: any, openFrom: string, service: IdexService, viewerRef: any, router: any, zone?: any, loader?: AppLoaderComponent, paths?: any, dataFolder?: any, tin?: any, isForm?: any) {
      loader.show();
      const annotationAttributes = await service.getAnnotation(item.id, true).toPromise();
      let xmlAnno = '';

      if (annotationAttributes) {

         xmlAnno = await service.getContentAnnotation(annotationAttributes.annotationId, annotationAttributes.annotationVersion).toPromise();

         let webViewerOptions: WebViewerOptions = {
            licenseKey: environment.pdfTronKey.toString(),
            path: '../assets/lib',
            fullAPI: true,
            enableAnnotations: true,
            filename: item.name,
         };
         const token = service.user.token;
         const url = service.url + '/content?id=' + item.id + '&token=' + token;
         const docUrl = url + '&isPdfTron=true&' + Date.now();
         webViewerOptions.initialDoc = docUrl.toString();

         WebViewer(webViewerOptions, viewerRef).then(async instance => {
            const {Core} = instance;
            const {documentViewer} = Core;
            const annotMana = documentViewer.getAnnotationManager();
            documentViewer.addEventListener('documentLoaded', async () => {
               await documentViewer.getDocument().getDocumentCompletePromise();
               const doc = documentViewer.getDocument();
               await annotMana.importAnnotations(xmlAnno);

               if (openFrom === 'create-task') {

                  await genFileToTransForm(instance, item, doc, item.id, zone, openFrom, service, router, paths, dataFolder, tin);
                  loader.hide();

               } else if (openFrom === 'sign-off') {

                  await genFileToTransForm(instance, item, doc, item.id, zone, openFrom, service, router);
                  loader.hide();

               }
            });
         });
      } else {
         if (openFrom === 'sign-off') {
            let path = location.pathname + location.search;
            const idex = '/idex';
            if (path.startsWith(idex)) {
               path = path.substring(idex.length);
            }
            localStorage.setItem('url', Path.combine(path));
            router.navigate(['/sign-off', item.id]);
         }
         if (openFrom === 'create-task') {
            let path = location.pathname + location.search;
            const idex = '/idex';
            if (path.startsWith(idex)) {
               path = path.substring(idex.length);
            }
            localStorage.setItem('url', Path.combine(path));
            const pathStartFlow = paths.map((data) => data['name']).join('/');
            localStorage.setItem('paths', pathStartFlow);
            let folderId;
            if (dataFolder) {
               folderId = dataFolder.parent.nodeRef.split('/')[3];
            } else {
               folderId = '';
            }
            const siteId = tin || 'My Files';

            localStorage.setItem('folderId', folderId);

            if (!isForm) {
               service.convertPdfTemplate(item.id)
                  .subscribe(data => {
                     router.navigate(['/create-task'],
                        {
                           queryParams: {
                              data: JSON.stringify({
                                 item: {
                                    id: item.id,
                                    isForm: false
                                 },
                                 typeName: 'startFlow'
                              }),
                              siteId: siteId
                           }
                        });
                  }, error => {
               });
            } else {                  
               router.navigate(['/create-task'],
               {
                  queryParams: {
                     data: JSON.stringify({
                        item: {
                           id: item.id,
                           isForm: isForm
                        },
                        typeName: 'startFlow'
                     }),
                     siteId: siteId
                  }
               });
            }
         }
      }
}

async function genFileToTransForm(instance: WebViewerInstance, item: any, doc: Core.Document, id: any, zone: any, openFrom: string,
      service: any, router: any, paths?: any, dataFolder?: any, tin?: any) {
      const lastIndex = item.name.lastIndexOf('.');
      const fileNameWithoutExt = item.name.substring(0, lastIndex);
      const {SaveOptions} = instance.Core;
      const xfdfString = await instance.Core.annotationManager.exportAnnotations();
      const options = {xfdfString, flags: SaveOptions.REMOVE_UNUSED};
      const data = await doc.getFileData(options);
      const arr = new Uint8Array(data);
      const blob = new Blob([arr], {type: 'application/pdf'});
      const file = blobToFile(blob, fileNameWithoutExt + '.pdf');
      uploadDoc(service, router, file, id, zone, openFrom, paths, dataFolder, tin);
}

function uploadDoc(service: any, router: any, fileUpload: any, id: any, zone: any, openFrom: string, paths?: any, dataFolder?: any, tin?: any) {
   const chunkSize = 1048576;

   function init(loopFile): Observable<any> {
      return service.get('/init/upload/' + loopFile);
   }

   function finish(key: string, path: string, file: any, tin: string, loopFile: any, id?: string) {
      const body = {
         name: file.fullPath || file.name,
         destination: path,
         mimeType: file.type,
         tin: tin,
         id: ''
      };
      service.uploadDocumentTemp('temp', body, loopFile, key).subscribe((response) => {

         let docList = [];

         if (openFrom === 'sign-off') {
            let path = location.pathname + location.search;
               const idex = '/idex';
               if (path.startsWith(idex)) {
                  path = path.substring(idex.length);
               }
               localStorage.setItem('url', Path.combine(path));
               docList.push(response.docId);
               const encode = btoa(response.docId);
               service.transformPdf(docList).subscribe(() => {
                  zone.run(() => {
                     router.navigate(['/sign-off', id, encode]);
                  });
               });
         }
         if (openFrom === 'create-task') {

            let path = location.pathname + location.search;
            const idex = '/idex';
            if (path.startsWith(idex)) {
               path = path.substring(idex.length);
            }
            localStorage.setItem('url', Path.combine(path));
            const pathStartFlow = paths.map((data) => data['name']).join('/');
            localStorage.setItem('paths', pathStartFlow);
            let folderId;
            if (dataFolder) {
               folderId = dataFolder.parent.nodeRef.split('/')[3];
            } else {
               folderId = '';
            }
            const siteId = tin || 'My Files';
            docList.push(response.docId);
            localStorage.setItem('folderId', folderId);
            const encode = btoa(response.docId);
            service.transformPdf(docList).subscribe((data) => {
               zone.run(() => {
                  router.navigate(['/create-task'],
                  {
                     queryParams: {
                        data: JSON.stringify({
                           item: {
                              id: id,
                              tempId: encode,
                           },
                           typeName: 'startFlow'
                        }),
                        siteId: siteId
                     }
                  });
               });
            });

         }
      }, error => {
         if (error.status === 413) {
            file.error = error.message;
         }
      });
   }

   init(1).subscribe(result => {
      const key = result.key;
      const fileNo = result.fileNo;
      let offset = 0;
      const xhr = new XMLHttpRequest();
      const send = () => {
         const end = Math.min(offset + chunkSize, fileUpload.size);
         xhr.open('PUT', service.url + '/upload/' + key, true);
         xhr.setRequestHeader('x-auth-token', service.user.token);
         xhr.setRequestHeader('Content-Range', 'bytes ' + offset + '-' + (end - 1) + '/' + fileUpload.size);
         const blob = fileUpload.slice.call(fileUpload, offset, end);
         xhr.send(blob);

      };
      xhr.onload = () => {
         if (xhr.status === 308) {
            if (fileUpload.canceled) {
               service.post('/cancel/upload/' + key, null).subscribe(() => { },
                  (err) => {
                     console.error(err);
                  });
               return;
            }
            offset += chunkSize;
            send();
         } else if (xhr.status === 201) {
            if (openFrom === 'sign-off') {
               finish(key, '', fileUpload, '', fileNo, id);
            } else if (openFrom === 'create-task') {
               finish(key, '', fileUpload, tin, fileNo, id);
            }
         }
      };
      send();
   }, error => {
      fileUpload.error = error;
      if (error.status === 401) {
      }
   });
}

function blobToFile(theBlob: Blob, fileName: string) {
   return new File([theBlob], fileName, { lastModified: new Date().getTime(), type: theBlob.type });
}

